import { useEffect, useState } from "react";

/** Display-only clock; the server still decides whether a reward can be claimed. */
export function useInboxMessageTime(
    createdAt: string,
    deadline: string | null,
    locale: string,
) {
    const [now, setNow] = useState(Date.now);

    useEffect(() => {
        const update = () => setNow(Date.now());
        update();
        const timer = window.setInterval(update, deadline ? 1_000 : 60_000);
        document.addEventListener("visibilitychange", update);
        return () => {
            window.clearInterval(timer);
            document.removeEventListener("visibilitychange", update);
        };
    }, [deadline]);

    const ageSeconds = Math.max(0, (now - Date.parse(createdAt)) / 1_000);
    const [unit, divisor]: [Intl.RelativeTimeFormatUnit, number] =
        ageSeconds >= 86_400
            ? ["day", 86_400]
            : ageSeconds >= 3_600
              ? ["hour", 3_600]
              : ["minute", 60];
    const ageLabel = new Intl.RelativeTimeFormat(locale, {
        style: "narrow",
    }).format(-Math.floor(ageSeconds / divisor), unit);
    const remaining = deadline
        ? Math.max(0, Math.ceil((Date.parse(deadline) - now) / 1_000))
        : null;
    const countdown =
        remaining === null
            ? undefined
            : [
                  Math.floor(remaining / 3_600),
                  Math.floor((remaining % 3_600) / 60),
                  remaining % 60,
              ]
                  .map((value) => String(value).padStart(2, "0"))
                  .join(":");

    return { ageLabel, countdown, deadlineReached: remaining === 0 };
}
